import { Component, inject, OnInit } from '@angular/core';
import { Table, TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ChargeService } from '../../../../services/charge.service';
import { CustomResponse } from '../../../../interfaces/custom-response.model';

@Component({
  selector: 'app-charge-list',
  standalone: true,
  imports: [TableModule, IconFieldModule, InputIconModule, ButtonModule, CommonModule, InputTextModule],
  templateUrl: './charge-list.component.html',
  styleUrl: './charge-list.component.css'
})
export class ChargeListComponent implements OnInit {

  chargeService = inject(ChargeService);

  charges: any[] = [];
  searchValue: string = "";

  loading: boolean = false;

  ngOnInit(): void {
    this.chargeService.getDashboardChargeList(0).subscribe({
      next: (data: CustomResponse) => {
        if (data.success == 1) {

        }
        this.charges = data.data.data;
        this.loading = false;
      }
    });

  }


  onGlobalFilter(table: Table, event: Event) {
    console.log(table);
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  clear(table: Table) {
    table.clear();
    this.searchValue = "";
  }
}
